module.exports = __webpack_public_path__ + "img/OBCINA CERKNO.0fccc655.png";